export interface SignInData {
  email?: string;
  password?: string;
  path: "pi" | "email";
  piAccessToken?: string;
}

export interface SignUpData extends SignInData {
  username?: string;
  profileImage?: string;
  invitationCode?: string;
}
export interface User {
  signUpMethod: string;
  id: string;
  arthereumBalance: number;
  picoinBalance: number;
  usdBalance: number;
  miningSessionsCount: number;
  email: string;
  password: string;
  lastMiningDate: any;
  referalsCount: number;
  profileImage: string;
  stakeBoost: number;
  referredBy?: string;
  username: string;
  emailVerified: boolean;
  lastLoginDate: any;
  lastLoginRewardDate?: any;
  currentStreak: number;
  luckyTagExpiry?: any;
  directBoostExpiry?: any;
  isPro?: boolean;
  proExpiry?: any;
  isLifetimePro?: boolean;
  referralCount?: number;
  turboChargeCount?: number;
  turboChargeExpiry?: any;
  extraSpins?: number;
  dailyStats?: {
    gamesPlayed: number;
    sharesCount: number;
    transfersCount: number;
    lastUpdate: string;
  };

  // Phase 7: Economy
  vaultItems?: string[];
  lockedATH?: number;
  stakingExpiry?: any;
  lastStakingRewardDate?: any;
  economyMissions?: {
    id: string;
    completed: boolean;
    date: string;
  }[];
  flashBoostExpiry?: any;

  // Revenue Boost: Pi Deposit tracking
  totalPiDeposited?: number;
  depositStreak?: number;
  lastDepositDate?: string;

  // Revenue Boost: New forge item effects
  immunityShieldExpiry?: any;
  doubleReferralExpiry?: any;
  luckyCharmSpins?: number;
  previousStreak?: number;
}
export interface UserModelData {
  user: User;
  miningInfos: MiningInfos;
}
export interface MiningInfos {
  baseGrant: number;
  nextGrantValue: number;
  nextGrantDate: any;
  miningReferredUserCount: number;
}
export interface StakeData {
  id: string;
  userUid: string;
  stakeBoost: number;
  piAmountStaked: number;
  period: number;
  createdAt: any;
  endsAt: any;
  unstaked: boolean;
  unstakedAt?: any;
  transactionHash: string;
}
export interface Transaction {
  id: string;
  userUid: string;
  amount: number;
  type: TransactionType;
}
export type TransactionType = "grant";

export type SupportedLanguageCode =
  | "en"
  | "fr"
  | "vi"
  | "zh"
  | "de"
  | "ko"
  | "id";
export type ThemeType = "dark" | "light";
export enum PAGE_NAME {
  LOGIN = "/login",
  USERNAME_SELECTION = "/UsernameSelectionPage",
  NAME_SELECTION = "/NamePage",
  GLOBALHOME = "/GlobalHomePage",
  CREATE = "/CreatePage",
  MY_FUTURE_PAGE = "/MyFuturePage",
  CHAT = "/ChatPage",
  BOOKMARKS = "/BookmarksPage",
  STORY_VIEW = "/STORY_VIEW",
  LIBRARY = "/LIBRARY",
  PROFILE = "/PROFILE",
  HOME = "/HOME",
  PROFILE_INSIGHTS = "/PROFILE_INSIGHTS",
  PROFILE_ALL_STORIES = "/PROFILE_ALL_STORIES",
  PROFILE_THOUGHTS = "/PROFILE_THOUGHTS",
  PROFILE_DREAMS = "/PROFILE_DREAMS",
  PROFILE_MEMORIES = "/PROFILE_MEMORIES",
  PROFILE_EXPERIENCES = "/PROFILE_EXPERIENCES",
  JOURNEY_PREMIUM = "/JOURNEY_PREMIUM",
  CHAT_HISTORY = "/CHAT_HISTORY",
  SETTINGS = "/SETTINGS",
  FRIENDS = "/FRIENDS",
  MEDIA = "/MEDIA",
  FRIEND_DISPLAY = "/FRIEND_DISPLAY",
  CREATE_FRIEND = "/CREATE_FRIEND",
  SEARCH_FRIEND = "/SEARCH_FRIEND",
  LANGUAGE_CHANGE = "/LANGUAGE_CHANGE",
  THEME_CHANGE = "/THEME_CHANGE",
  NOTIFICATIONS = "/NOTIFICATIONS",
  ONBOARDING_LOCAL = "/ONBOARDING_LOCAL",
  ATHEREUM_POINTS = "/ATHEREUM_POINTS",
  SHARE_WITH_FRIENDS = "/SHARE_WITH_FRIENDS",
  PINETWORK = "/PINETWORK",
  ONBOARDING_SIGN = "/ONBOARDING_SIGN",
  ONBOARDING_SIGN_UP = "/ONBOARDING_SIGN_UP",
  STAKE = "/STAKE",
  STAKE_SOME_PI = "/STAKE_SOME_PI",
  BASE_GRANT_EXPLANATION = "/BASE_GRANT_EXPLANATION",
  INVITE_USERS = "/INVITE_USERS",
  CRYPTO_DETAILS = "/CRYPTO_DETAILS",
  SEND_CRYPTO = "/SEND_CRYPTO",
  RECEIVE_CRYPTO = "/RECEIVE_CRYPTO",
  BUY_CRYPTO = "/BUY_CRYPTO",
  HYSTORY_PAGE = "/HYSTORY_PAGE",
  CLAIM_GRANT = "/CLAIM_GRANT",
  VERIFY_EMAIL = "/VERIFY_EMAIL",
  WALLET = "/WALLET",
  EXPLORER = "/EXPLORER",
  ONBOARDING_SIGN_UP_WITH_PI = "/ONBOARDING_SIGN_UP_WITH_PI",
  REFERRALS = "/REFERRALS",
  CRYPTO_VIEW_PAGE = "/CRYPTO_VIEW_PAGE",
  SWAP = "/SWAP",
  DEPOSIT = "/DEPOSIT",
  REWARDS = "/REWARDS",
  LUCKY_SPIN = "/LUCKY_SPIN",
  PRO = "/PRO",
  LEADERBOARD = "/LEADERBOARD",
  TREASURE_VAULT = "/TREASURE_VAULT",
  FORGE = "/FORGE",
  MYSTERY_BOX = "/MYSTERY_BOX",
  GAMES = "/GAMES",
  TAP_RUSH = "/TAP_RUSH",
  MEMORY_MATCH = "/MEMORY_MATCH",
  NUMBER_CRUNCH = "/NUMBER_CRUNCH",
  CRYPTO_QUIZ = "/CRYPTO_QUIZ",
  WATCH_AND_EARN = "/WATCH_AND_EARN",
  TERMS_OF_SERVICE = "/TermsOfService",
  PRIVACY_POLICY = "/PrivacyPolicy",
  COMMUNITY_CHAT = "/COMMUNITY_CHAT",
}
export type LeaderboardSortBy =
  | "arthereumBalance"
  | "miningSessionsCount"
  | "stakeBoost"
  | "createdAt"
  | "referalsCount";
export type LeaderboardSortDirection = "asc" | "desc";
